/*** IMPORTS FROM imports-loader ***/
var define = false;

export default {
	// init: (app, CookieManager) => {
	init: (app, Plyr, gsap) => {
		/*
		|
		| Constants
		|-----------
		*/
        const 
            $body         = $('body'),
            header        = document.querySelector('#header'),
            hero          = document.querySelector('.hero'),
            $cookieBanner = $('.cookie-banner'),
            $cookieClose  = $cookieBanner.find('.item-close'),
            $cookieAccept = $cookieBanner.find('.item-accept'),
            $cookieRefuse = $cookieBanner.find('.item-refuse'),
            $videoPlayers = $('.player-video')
		;

        // console.log( header );
        // console.log( hero );

        /*
		|
		| Cookie Manager
		|-----------------
		*/
        // new CookieManager($cookieBanner, {
        //     name: 'adveris_cookie_use',
        //     duration: 30,
        //     buttons: {
        //         accept: $cookieAccept,
        //         refuse: $cookieRefuse,
        //         close: $cookieClose
        //     },
        //     onAccept: () => {
        //         console.log('accpeted')
        //     },
        //     onRefuse: () => {
        //         console.log('refused')
        //     }
        // });

        /*
		|
		| Header
		|-----------------
		*/
        let
            offset 	   	  = 0,
            scrollTop  	  = 0,
            lastScrollTop = 0
        ;

        const stickyHeader = (scrollTop, offset, lastScrollTop) => {

            if ( scrollTop > offset ) {

                header.dataset.header = 'hide';
                    
                if ( scrollTop > lastScrollTop ) {

                    header.dataset.header = 'hide';
                    
                } else {

                    header.dataset.header = '';

                }

            } else {

                header.dataset.header = '';

            }

        }

        if ( header ) {

            offset 	   = hero ? hero.offsetHeight : header.offsetHeight;
            scrollTop  = window.scrollY;

            stickyHeader(scrollTop, offset, lastScrollTop);

        }


        /**
         *
         * Video Player's (w/ Plyr)
         *
         */
         $.each($videoPlayers, (index, element) => {

            // Getting HTML element inside container : Poster, Play Button, Plyr Container
            const $type       = $( element ).data('type');
            const $PlyPlayer  = $( element ).find('.PlyrPlayer')
            const $poster     = $( element ).find('.poster')
            const $playButton = $( element ).find('.play-icon')
            const $videoId    = $( $PlyPlayer ).attr('id', `plyr-player-${index + 1}`).attr('id');

            // Init Plyr Player by getting video ID
            let player = new Plyr(`#${$videoId}`, {
                controls : false
            });

            // player.on('ready', () => {
                // player.play();
            // })
              

            // console.log(player)
            
            // Create GSAP Timeline
            // const videoPlayerTimeline = gsap.timeline({
            //     paused: true,
            //     onStart: () => {

            //     },
            //     onComplete: () => {

            //     },
            //     onReverseComplete: () => {

            //     }
            // });

            // Perform Timeline Animation
            // videoPlayerTimeline
            //     .to($playButton, 0.4, { opacity: 0, scale: 0.5, zIndex: -1, ease: 'Power0.easeNone' }, 'start')
            //     .to($poster, 0.6, { opacity: 0, scale: 0.5, zIndex: -1, ease: 'Power1.easeOut' }, '-=0')

            /* Player Event's */

            // PlayButton Click
            // $playButton.on('click', () => {

            //     if ( videoPlayerTimeline.totalProgress() > 0 ) {

            //         player.pause();

            //     } else {

            //         player.play();

            //     }
            // });

            //     
            // if ( $type == 'file' ){

            //     videoPlayerTimeline.play();

            // }

            // Plyr : player event's (play | pause)    
            // player.on('play', () => { videoPlayerTimeline.timeScale(1).play(); });
            // player.on('pause', () => { videoPlayerTimeline.timeScale(1.2).reverse(); });
            

        })

        $body.on('loaderEnd', () => console.log('ended'))

        /**
         * Scroll
         */
		window.addEventListener('scroll', (e) => {

			scrollTop = window.scrollY;

			if ( header ) {
				stickyHeader(scrollTop, offset, lastScrollTop);
                lastScrollTop = scrollTop;
			}

		});

	}
}
